export default __webpack_public_path__ + "static/summer_containers54-31cacaca289451cdb8493eafb5a399f1.webp";